import { render, staticRenderFns } from "./ResetUAMPasswordModal.vue?vue&type=template&id=06986b59&scoped=true"
import script from "./ResetUAMPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetUAMPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ResetUAMPasswordModal.vue?vue&type=style&index=0&id=06986b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06986b59",
  null
  
)

export default component.exports